import { render, staticRenderFns } from "./rcc-cell.vue?vue&type=template&id=28b3e7c9&scoped=true&"
import script from "./rcc-cell.vue?vue&type=script&lang=js&"
export * from "./rcc-cell.vue?vue&type=script&lang=js&"
import style0 from "./rcc-cell.vue?vue&type=style&index=0&id=28b3e7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3e7c9",
  null
  
)

export default component.exports